import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import Menu from "./Menu";
import Logout from "./Logout";
import { view_user } from "../../stores/Users/view";
import LiLanguage from "components/Li/LiLanguage";
import _nav_global from "./_nav_global";
import _search from "./_search";

export default function Contents(Page) {
  const { type, dispatch_type, word, set_word } = Page ?? {};
  // const [inp, set_inp] = React.useState("");
  const ref_search = useRef();

  // const inp = sessionStorage.getItem("SearchWord");

  const history = useHistory();

  const location = useLocation();
  const focus = location.focus;

  const ref_id = useRef();

  if (focus) {
    if (ref_id) {
      if (ref_id.current) {
        ref_id.current.focus();
      }
    }
    // const ele = document.getElementById("almighty");
    // if (ele) {
    //   setTimeout(function() {
    //     ele.focus();
    //   }, 1000);
    // }
  }

  // let set_get = null;
  // if (Collections) {
  //   set_get = (name) => {
  //     Collections.dispatch_gets({ ...Collections.propsCollections.search, name });
  //   };
  // }
  // if (Items) {
  //   set_get = (name) => {
  //     Items.dispatch_gets({ ...Items.propsItems.search, name });
  //   };
  // }
  // if (Users) {
  //   set_get = (name) => {
  //     Users.dispatch_gets({ ...Users.propsUsers.search, name });
  //   };
  // }

  const dispatch = useDispatch();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);
  const reduce_post_authin = useSelector((state) => state.reduce_post_authin);

  const user = reduce_get_accounts.user;
  const v_user = view_user(user);

  useEffect(() => {}, []);

  const la = sessionStorage.getItem("AcceptLanguage");
  const token = reduce_post_authin.token;
  const mail_address = reduce_get_accounts?.user?.mail_address;
  const user_name = reduce_get_accounts?.user?.username;
  const display_name = reduce_get_accounts?.user?.display_name;
  return (
    <>
      <header className="navbar navbar-light navbar-expand-md align-items-center sticky-top">
        <div className="container">
          <button
            type="button"
            className="navbar-toggler me-2"
            data-bs-toggle="offcanvas"
            data-bs-target="#globalNav"
            aria-controls="globalNav"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <h1 className="navbar-brand">
            <a
              className="tmty-brand"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/home`,
                });
              }}
            >
              <img
                src="/dist/tmty/assets/brand/tomonity-typography.webp"
                width="auto"
                height="auto"
                alt="tomonity"
              />
            </a>
          </h1>
          <div className="flex-grow-1 px-3 d-none d-sm-block" action="">
            <div className="search-control">
              <input
                id="almighty"
                type="search"
                // autoFocus={true}
                className="form-control"
                ref={ref_id}
                list="datalistOptions"
                placeholder={t("何かお探しですか？")}
                aria-label="Search"
                value={word}
                onChange={(e) => {
                  const val = e.target.value;
                  sessionStorage.setItem("SearchWord", val);
                  if (set_word) {
                    set_word(val);
                  }
                }}
                onFocus={() => {
                  if (set_word) {
                  } else {
                    history.push({
                      pathname: `/explore`,
                      focus: true,
                    });
                  }
                }}
              />
            </div>
            <datalist id="datalistOptions">
              {/* <option value="\u30C7\u30A3\u30BA\u30CB\u30FC"></option>
              <option value="\u30C7\u30A3\u30BA\u30CB\u30FC \u30D7\u30EA\u30F3\u30BB\u30B9"></option>
              <option value="\u30C7\u30A3\u30BA\u30CB\u30FC \u30B9\u30B1\u30C3\u30C1"></option>
              <option value="\u30C7\u30A3\u30BA\u30CB\u30FC \u516C\u5F0F"></option>
              <option value="\u30C7\u30A3\u30BA\u30CB\u30FC \u59EB"></option> */}
            </datalist>
            <button className="btn btn-outline-secondary d-none" type="button">
              {t("検索")}
            </button>
          </div>
          <button
            type="button"
            className="btn btn-white ms-auto d-sm-none"
            role="button"
            data-bs-toggle="modal"
            data-bs-target="#searchField"
            onClick={() => {
              // if (ref_search) {
              // setTimeout(() => {
              // if (ref_search.current) {
              //   ref_search.current.focus();
              // }
              // }, 1000);
              // }
            }}
          >
            <img src="/dist/tmty/assets/icons/magnifyingglass.svg" alt="Search" />
          </button>
          {_nav_global()}

          {!token && (
            // <a
            //   className="btn btn-primary rounded-pill ms-2 px-3"
            //   href="#"
            //   onClick={(e) => {
            //     e.preventDefault();
            //     history.push({
            //       pathname: `/signin`,
            //     });
            //   }}
            // >
            //   ログイン
            // </a>
            <div className="nav-item dropdown d-none d-md-block">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarSignin"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-circle-user lead" />
              </a>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarSignin">
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const pathname = window.location.pathname;
                      sessionStorage.setItem("PATH_FIRST", pathname);
                      history.push({
                        pathname: `/signin`,
                      });
                    }}
                  >
                    <i className="fa-solid fa-arrow-right-to-bracket fa-fw me-3" />
                    {t("ログイン")}
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/signup`,
                      });
                    }}
                  >
                    <i className="fa-solid fa-circle-user fa-fw me-3" />
                    {t("アカウントを作成")}
                  </a>
                </li>
              </ul>
            </div>
          )}
          {token && (
            <>
              <div
                className="icon icon-pill"
                style={{
                  maxWidth: "110px",
                }}
              >
                <a
                  className="text-body d-flex align-items-center"
                  href="javascript:void(0)"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#accountsNav"
                  aria-controls="accountsNav"
                >
                  <img
                    src={v_user.user_icon_uri}
                    className="icon-item"
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                    }}
                  />
                  <span className="d-none d-lg-block ms-2 text-truncate">{display_name}</span>
                </a>
              </div>
              {/* <button
                type="button"
                className="btn btn-white"
                data-bs-toggle="offcanvas"
                data-bs-target="#accountsNav"
                aria-controls="accountsNav"
              >
                <span className="position-relative">
                  <img
                    src={v_user.user_icon_uri}
                    className="rounded-circle border"
                    width={36}
                    height={36}
                    alt="My page"
                  />
                  <small className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">
                    99+
                    <span className="visually-hidden">未読の通知</span>
                  </small>
                </span>
              </button> */}
            </>
          )}
        </div>
      </header>
      <nav
        className="offcanvas offcanvas-end offcanvas-my"
        tabIndex={-1}
        id="accountsNav"
        aria-labelledby="accountsNavLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="accountsNavLabel">
            <a
              className="tmty-brand tmty-brand-full d-md-none"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/home`,
                });
              }}
            >
              <img
                src="/dist/tmty/assets/brand/tomonity-typography.webp"
                width="auto"
                height="auto"
                alt="tomonity"
              />
            </a>
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body p-0">
          <Menu myhome={false} suffix={"-h"} />
        </div>
      </nav>
      <Logout />
      {_search({ ...Page, ref_search })}
    </>
  );
}
